import { addDoc, collection, doc, getDocs, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase/config";

export interface Prompt {
    id: string;
    name: string;
    template: string;
    description: string;
    variables: string[];
    created: any;
    lastUpdated: any;
}

export interface SourceMaterial {
  id: string;
  sourceDocument: string;
  content: string;
  topicTags: string[];
  dataTypeTags: string[];
  version: number;
  status: string;
  embeddingVersion: number;
  embeddingGeneratedAt: any;
  vectorIndexed: boolean;
  created: any;
  lastUpdated: any;
}

export interface chunkFormData {
  id: string;
  content: string;
  sourceDocument: string;
  topicTags: string[];
  dataTypeTags: string[];
  topicTagsInput: string;
  dataTypeTagsInput: string;
}

class LLMManagementService {

    async getSourceMaterialChunks(): Promise<SourceMaterial[]> {
        const chunksRef = collection(db, 'sourceMaterial');
        
        // Try simple query first to see if there are any documents
        const simpleSnapshot = await getDocs(chunksRef);
        console.log('Total documents in sourceMaterial collection:', simpleSnapshot.docs.length);
        
        if (simpleSnapshot.empty) {
            console.log('No documents found in sourceMaterial collection');
            return [];
        }
        
        return simpleSnapshot.docs.map(doc => {
            const data = doc.data();
            return {
                id: doc.id,
                ...data,
            };
        }) as SourceMaterial[];
    }

    async getLLMPrompts(): Promise<Prompt[]> {
        const promptsRef = collection(db, 'llmPrompts');
        
        // Try simple query first to see if there are any documents
        const simpleSnapshot = await getDocs(promptsRef);
        console.log('Total documents in llmPrompts collection:', simpleSnapshot.docs.length);
    
        
        return simpleSnapshot.docs.map(doc => {
            const data = doc.data();
            return {
                id: doc.id,
                ...data,
            };
        }) as Prompt[];
    }

    async updatePrompt(promptId: string, updatedData: Partial<Prompt>): Promise<void> {
        const ref = doc(db, 'llmPrompts', promptId);

        const data = {
            lastUpdated: serverTimestamp(),
            ...updatedData,
        }

        await updateDoc(ref, data);
    }

    async createPrompt(promptData: Omit<Prompt, 'id' | 'created' | 'lastUpdated'>): Promise<string> {
        const promptsRef = collection(db, 'llmPrompts');

        const data = {
            ...promptData,
            created: serverTimestamp(),
            lastUpdated: serverTimestamp(),
        }

        const docRef = await addDoc(promptsRef, data);
        return docRef.id;
    }
}

export const llmManagementService = new LLMManagementService();